export enum XpacFilter {
  Online = "online",
  Offline = "offline",
  License = "license",
  NoLicense = "noLicense",
  Issues = "issues",
  NoIssues = "noIssues"
}